module.exports = __webpack_public_path__ + "static/img/home-2.fab7c8d7.png";